export const transactionStatus = {
  'started': 1,
  'completed': 2,
  'failed': 3,
  'backup': 4,
  'restoring': 5,
  'processing': 6,
};

export const catalogTransactions = {
  'japan': {
    'fileType': 'text/plain',
    'transaction': 'JAPAN_PARTS_LIST',
  },
  'others': {
    'fileType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'transaction': 'OTHERS_PARTS_LIST',
  },
};

export const stockAdjustmentStates = {
  'enter': 'INGRESADO',
  'sent': 'ENVIADO',
  'removed': 'ELIMINADO',
  'approved': 'APROBADO',
  'rejected': 'RECHAZADO',
};

export const returnsStatus = {
  'C': 'CERRADO',
  'E': 'ENVIADO',
  'I': 'INGRESADO',
};

export const returnClaimTypes = {
  'F': 'FALTANTE',
  'E': 'EQUIVOCADO',
  'D': 'DAÑO',
  'I': 'INCOMPLETO',
  'S': 'SOBRANTE',
  'O': 'OTRO',
};

export const returnRequestTypes = {
  'CA': 'CAMBIO',
  'RE': 'REPOSICION',
  'DE': 'DEVOLUCION',
  'NC': 'NOTA DE CREDITO',
  'OT': 'OTRO',
};

export const returnAcceptanceTypes = {
  'A': 'TDE ACEPTA LA SOLICITUD',
  'R1': 'SOLICITUD ENVIADA POSTERIOR A 5 DIAS LABORABLES',
  'R2': 'EVIDENCIA NO SUSTENTA LA SOLICITUD / FALTA DE DOCUMENTOS',
  'R3': 'TDE TIENE INFORMACIÓN SUSTENTABLE PARA RECHAZO',
  'R4': 'INCUMPLE POLÍTICA DE DEVOLUCIÓN ESTABLECIDA',
};

export const warehouses = {
  'main': 'CPD',
  'lubricants': 'LBR',
};

export const importsTrackingStatus = {
  'dispatch_confirmation': 'C',
  'transit': 'T',
  'nationalization': 'N',
  'country_arrival': 'A',
  'labeling': 'E',
  'movilization': 'M',
  'cargo_recieved': 'R',
};

export const wtsDefaultArea = 'SERVICIO';


export const abisStatusList = [
  {'text': 'CANCEL', 'value': 'CANCEL'},
  {'text': 'WAITING', 'value': 'WAITING'},
  {'text': 'SHIPPED', 'value': 'SHIPPED'},
];

export const etasManagementAlertsList = [
  {'text': 'INGRESADO', 'value': 'INGRESADO'},
  {'text': 'REVISIÓN', 'value': 'REVISIÓN'},
  {'text': 'SEGUIMIENTO', 'value': 'SEGUIMIENTO'},
  {'text': 'ALERTA', 'value': 'ALERTA'},
];
